import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Fallback component to display when BlogDashboard fails to load
 */
const BlogDashboardFallback = ({ error }) => {
  return (
    <div className="w-full min-h-screen bg-white p-8 flex flex-col items-center justify-center">
      <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-6">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-10 w-10 text-red-500" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
          />
        </svg>
      </div>
      
      <h1 className="text-2xl font-bold text-gray-800 mb-4">
        Blog Dashboard Error
      </h1>
      
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 max-w-lg text-center">
        <p className="text-red-700 mb-2">
          {error?.message || "Failed to load the Blog Dashboard component."}
        </p>
        <details className="text-sm text-gray-600 text-left">
          <summary className="cursor-pointer text-red-500 hover:text-red-700">View technical details</summary>
          <pre className="mt-2 bg-gray-100 p-3 rounded text-xs overflow-auto">
            {error?.stack || JSON.stringify(error, null, 2) || 'No error details available'}
          </pre>
        </details>
      </div>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/">
          <button className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors duration-200">
            Go to Home
          </button>
        </Link>
        
        <button 
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
        >
          Reload Page
        </button>
      </div>
      
      <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-4 max-w-lg">
        <h3 className="font-medium text-yellow-800 mb-2">Troubleshooting tips:</h3>
        <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
          <li>Check the browser console for more detailed error messages</li>
          <li>Ensure all required dependencies are installed (jwt-decode, dompurify)</li>
          <li>Verify that your API server is running and accessible</li>
          <li>Clear your browser cache and reload the page</li>
        </ul>
      </div>
    </div>
  );
};

export default BlogDashboardFallback; 